export enum FilterTime {
  PRIOR7 = 'PRIOR7',
  PRIOR30 = 'PRIOR30',
  ALL_TIME = 'ALL_TIME',
}
